// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"DocumentGrid_gridContainer__2J23E","gridOverlay":"DocumentGrid_gridOverlay__1YvvE"};